import { ElementType } from "react";

import { DialogType } from "@ryde/shared";

import {
  BookingBulkSetConflictApprovalReasonDialog,
  BookingBulkSetConflictApprovalReasonMultiPassengersDialog,
  BulkArchiveRelationErrorDisplayDialog,
  DialogRideConfirm,
  DialogsInfo,
} from "./components";

export const dialogsRegister: Record<DialogType, ElementType> = {
  [DialogType.Info]: DialogsInfo,
  [DialogType.RideConfirm]: DialogRideConfirm,
  [DialogType.BookingBulkSetConflictApprovalReason]:
    BookingBulkSetConflictApprovalReasonDialog,
  [DialogType.BookingBulkSetConflictApprovalReasonMultiPassengers]:
    BookingBulkSetConflictApprovalReasonMultiPassengersDialog,
  [DialogType.BulkArchiveRelationErrorDisplayDialog]:
    BulkArchiveRelationErrorDisplayDialog,
};
